import { Card } from '../../common/Card';

export const BasemapControl = ({ basemaps, activeBasemapId, onChange }) => {
  return (
    <Card className="p-4 space-y-3 map-panel-card">
      <h3 className="text-lg font-black flex items-center gap-2 text-gray-900">
        <span>🗺️</span>
        اختر شكل الخريطة
      </h3>
      <div className="grid grid-cols-1 gap-2">
        {basemaps.map((basemap) => {
          const isActive = basemap.id === activeBasemapId;
          return (
            <button
              key={basemap.id}
              type="button"
              onClick={() => onChange(basemap.id)}
              className={`map-basemap-option ${isActive ? 'map-basemap-option-active' : ''}`}
            >
              <div className="flex items-center gap-2">
                <span className="text-lg">{basemap.preview || '🧭'}</span>
                <span className="text-sm font-semibold">{basemap.label}</span>
              </div>
              <span className="text-xs opacity-80">{basemap.hint}</span>
            </button>
          );
        })}
      </div>
    </Card>
  );
};
